<template>
  <div class="landing-page pt-4">
    <section class="hero-section">
      <div class="container mb-4">
        <h1 class="title">AI Mastering Service</h1>
        <p class="description">{{ $t('mastering_title_description') }}</p>
        <p class="description">{{ $t('mastering_description_2') }}</p>
        <p class="description">{{ $t('mastering_description_3') }}</p>
        <div class="text-center p-3 mb-4">
          <router-link :to="getLoginUrl('landing-mastering')" class="btn btn-primary btn-lg">{{ $t('start_now') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LandingMastering',
  data: function () {
    return {
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      user: {},
      lang: 'en'
    }
  },
  methods: {
    getLoginUrl: function (identifier) {
      let baseUrl = ''
      if (location.host.match(/free-music-distribution/)) {
        baseUrl = 'https://indiefy.net'
      }

      if (this.$user && this.$user._id) {
        return `${baseUrl}/tools/mastering`
      } else {
        if (navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)) {
          return `${baseUrl}/login?next=/tools/mastering`
        }

        if (identifier) {
          return `${baseUrl}/login?from=${identifier}&next=/tools/mastering`
        }
        return `${baseUrl}/login?next=/tools/mastering`
      }
    }
  },
  created: function () {
    this.basePath = `${location.protocol}//${location.host}${location.pathname}`
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)
    this.user = this.$user

    if (this.$route.query.utm_source) {
      localStorage.setItem('user_source', this.$route.query.utm_source)
      localStorage.setItem('user_medium', this.$route.query.utm_medium)
      localStorage.setItem('user_campaign', this.$route.query.utm_campaign)
    }

    if (this.$i18n.locale === 'es') {
      window.$('meta[name="description"]').attr('content', this.$route.meta.description_es)
      window.$('meta[property="og:description"]').attr('content', this.$route.meta.description_es)
    } else {
      window.$('meta[name="description"]').attr('content', this.$route.meta.description)
      window.$('meta[property="og:description"]').attr('content', this.$route.meta.description)
    }

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.isMobileApp) {
      if (this.user._id) {
        return this.$router.push(`/dashboard`)
      } else {
        return this.$router.push('/login')
      }
    }
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/LandingMastering.vue